import { useMemo, useRef } from "react";
import { useLocation } from "react-router-dom";

import { useFirebase } from "firebase";

import { handoffFor } from "./handoff";
import { submissionStatusClientFor } from "./submissionStatusClient";

/** The submission status client, sending the signed-in visitor's token and
 * the page's signed handoff as they stand when each request is made. */
export function useStatusClient(): ReturnType<
  typeof submissionStatusClientFor
> {
  const { user } = useFirebase();
  const { search } = useLocation();
  const userRef = useRef(user);
  userRef.current = user;
  const searchRef = useRef(search);
  searchRef.current = search;
  return useMemo(
    () =>
      submissionStatusClientFor(
        async () => (await userRef.current?.getIdToken()) ?? null,
        (submissionId) => handoffFor(searchRef.current, submissionId),
      ),
    [],
  );
}
